"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var formik_1 = require("formik");
var react_1 = __importStar(require("react"));
var __1 = require("../../../");
var context_1 = require("../../../../context");
var enums_1 = require("../../../../types/enums");
var utils_1 = require("../../../../utils");
var Card_1 = require("../../../Card");
var Checkbox_1 = __importDefault(require("../../../Checkbox"));
var Tabs_1 = require("../../../Tabs/Tabs");
var TextArea_1 = __importDefault(require("../../../TextArea"));
exports.errorKeys = [
    'referrer_signpost_to',
    'client_followup_call',
    'client_followup_number',
    'client_followup_call_date',
    'client_followup_call_time',
    'energy_efficiency_install_consent',
    'energy_efficiency_install_consent_why',
    'energy_efficiency_measure',
    'energy_efficiency_measure_why',
];
var efficiencyOptions = [
    'draughtproofing_door',
    'draughtproofing_strip',
    'draughtproofing_letterbox',
    'draughtproofing_excluder',
    'light_bulbs_led',
    'power_downs',
    'radiator_panels',
    'energy_monitors',
    'dehumidifiers',
    'shower_head',
    'save_a_flush',
    'shower_time',
    'tap_aerator',
];
var OnwardReferralForm = function (_a) {
    var tabId = _a.tabId;
    var _b, _c, _d;
    var _e = context_1.useSemantics(), options = _e.options, trans = _e.trans;
    var setTabError = Tabs_1.useTabsContext().setTabError;
    var _f = formik_1.useFormikContext(), values = _f.values, errors = _f.errors;
    var _g = react_1.useState(((_b = errors.project) === null || _b === void 0 ? void 0 : _b.onward_referral) || {}), formErrors = _g[0], setFormErrors = _g[1];
    react_1.useEffect(function () { return setTabError(tabId, utils_1.objectHasAnyKey(formErrors, exports.errorKeys)); }, [formErrors]);
    react_1.useEffect(function () { var _a; return setFormErrors(((_a = errors.project) === null || _a === void 0 ? void 0 : _a.onward_referral) || {}); }, [
        (_c = errors.project) === null || _c === void 0 ? void 0 : _c.onward_referral,
    ]);
    var onv = values.project.onward_referral || {};
    var onerr = ((_d = errors.project) === null || _d === void 0 ? void 0 : _d.onward_referral) || {};
    return (react_1.default.createElement(Card_1.Card, { heading: trans('project:slhh::headings.onward-referral'), subHeading: trans('project:slhh::headings.project') },
        react_1.default.createElement(__1.FormControl, { errors: onerr.referrer_signpost_to, label: trans('project:slhh::labels.referrer-signpost-to') },
            react_1.default.createElement(__1.Input, { fast: true, name: "project.onward_referral.referrer_signpost_to", maxLength: 200 })),
        react_1.default.createElement(__1.FormControl, { errors: onerr.client_followup_call, label: trans('project:slhh::labels.client-followup-call'), help: trans('project:slhh::help.client-followup-call'), showOther: onv.client_followup_call === enums_1.BooleanOption.YES, other: react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(__1.FormControl, { errors: onerr.client_followup_number, help: trans('project:slhh::help.client-followup-number'), label: trans('project:slhh::labels.client-followup-number') },
                    react_1.default.createElement(__1.Input, { fast: true, name: "project.onward_referral.client_followup_number", maxLength: 200 })),
                react_1.default.createElement(__1.FormControl, { errors: onerr.client_followup_call_date, help: trans('project:slhh::help.client-followup-call-date'), label: trans('project:slhh::labels.client-followup-call-date') },
                    react_1.default.createElement(__1.Input, { fast: true, name: "project.onward_referral.client_followup_call_date", maxLength: 200 }))) },
            react_1.default.createElement(__1.Select, { width: "xs", options: options.boolean(), name: "project.onward_referral.client_followup_call" })),
        react_1.default.createElement(__1.FormControl, { errors: onerr.energy_efficiency_install_consent, label: trans('project:slhh::labels.energy-efficiency-install-consent'), showOther: onv.energy_efficiency_install_consent === enums_1.BooleanOption.NO, other: react_1.default.createElement(__1.FormControl, { errors: onerr.energy_efficiency_install_consent_why, label: trans('project:slhh::labels.energy-efficiency-install-consent-why') },
                react_1.default.createElement(TextArea_1.default, { fast: true, name: "project.onward_referral.energy_efficiency_install_consent_why", maxLength: 5000 })) },
            react_1.default.createElement(__1.Select, { width: "xs", options: options.boolean(), name: "project.onward_referral.energy_efficiency_install_consent" })),
        react_1.default.createElement(__1.FormControl, { errors: onerr.energy_efficiency_measure, label: trans('project:slhh::labels.energy-efficiency-measure') },
            react_1.default.createElement("div", { className: "flex flex-col" }, efficiencyOptions.map(function (key) { return (react_1.default.createElement(Checkbox_1.default, { key: "energy_efficiency_measure." + key, name: "project.onward_referral.energy_efficiency_measure", label: trans("project:slhh::enum.energy-efficiency-measure." + key), value: key })); }))),
        react_1.default.createElement(__1.FormControl, { flush: true, errors: onerr.energy_efficiency_measure_why, label: trans('project:slhh::labels.energy-efficiency-measure-why') },
            react_1.default.createElement(__1.Input, { fast: true, name: "project.onward_referral.energy_efficiency_measure_why", maxLength: 200 }))));
};
exports.default = OnwardReferralForm;
//# sourceMappingURL=OnwardReferralForm.js.map